import { HttpClient } from '@adapters/HttpClient';

export class CategoryApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<{ id: string; name: string }[]> {
    const raw = await this.httpClient.get<any>('/categories');
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((cat: any) => ({
      id: String(cat.id),
      name: cat.name,
    }));
  }
}
